import React from "react";
import FormDemo from "../HomeSections/FormDemo";

const Contact = () => {
  return (
    <>
      <FormDemo />
    </>
  );
};

export default Contact;
